// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2zfuZ","info":"Note_info__2JdW7","note":"Note_note__2D4Em","actions":"Note_actions__2M3MT"};